module.exports = __webpack_public_path__ + "assets/icon-link.26aae7cb.svg";